'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var taxonomyNodePropType = _propTypes2.default.shape({
  _id: _propTypes2.default.string,
  name: _propTypes2.default.string
});

exports.default = taxonomyNodePropType;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/PropTypes/recentlyVisitedPropType.js
// module id = 274
// module chunks = 11